module.exports = __webpack_public_path__ + "img/17.8977c079.png";